import React from "react";
import About from "./ui/components/about/about";
import Home from "./ui/components/home/home";
import ProjectExplore from "./ui/components/projects/projectExplore/projectExplore";
import ViewAll from './ui/components/projects/viewAll/viewall';
import { ImageUploader } from "./ui/components/upload/upload";


const routes = [
    {
        path: "/",
        component: Home,
        exact: true
    },
    {
        path: "/about",
        component: About,
        exact: true
    },
    {
        path: "/explore/project/:id",
        component: (data:any) => {
            return <ProjectExplore {...data}/>
        },
        state: { scrollToTop: true }
    },
    {
        path: "/explore/all",
        component: ViewAll,
    },
    {
        path: "/image",
        component: ImageUploader,
    }
];

export default routes;